export default __webpack_public_path__ + "static/media/ic_sentiment_satisfied_48px.6f4a9aa2.svg";